import { MIS_PMO_HEALTH_CHECK } from '../../Api/resources/endPoint';
import { serviceName } from '../../Api/resources/serviceConstants';

export const fetchPMOHealthCheck = (requestBody) => {
  return {
    url: MIS_PMO_HEALTH_CHECK,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestBody,
    service: serviceName.PROJECT_MS,
  };
};
